<div class="recap-item pb-4">
    <p class="recap-label">Linea investimento attuale</p>
    <p class="recap-value">{{ actualInvestmentLineDescription }}</p>
</div>

<app-basic-form [form]="form" [keys]="keys"></app-basic-form>

@if (currentLineAssets && newLineAssets && currentLineAssets.length > 0 && newLineAssets.length > 0) {
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="500ms">
        <mat-tab label="DATI SWITCH">
            <div class="recap-table">
                <div>
                    <p class="recap-label">Fondi Provenienza</p>
                    <app-basic-table [dataset]="currentLineAssets" [tableKeys]="assetsTableKeys"></app-basic-table>
                </div>
    
                <div>
                    <p class="recap-label">Fondi Destinazione</p>
                    <app-basic-table [dataset]="newLineAssets" [tableKeys]="assetsTableKeys"></app-basic-table>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="DATI REINDIRIZZAMENTO">
            <div class="recap-table">
                <div>
                    <p class="recap-label">Situazione attuale</p>
                    <app-basic-table [dataset]="currentLineAssets" [tableKeys]="situationTableKeys"></app-basic-table>
                </div>
    
                <div>
                    <p class="recap-label">Nuova attribuzione</p>
                    <app-basic-table [dataset]="newLineAssets" [tableKeys]="situationTableKeys"></app-basic-table>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
}